import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TooltipDirective } from '@kros-sk/ui/tooltip';

import { SaveIndicatorComponent } from './save-indicator.component';

/** @deprecated Use standalone SaveIndicatorComponent instead.*/
@NgModule({
  imports: [CommonModule, ReactiveFormsModule, TooltipDirective, SaveIndicatorComponent],
  exports: [SaveIndicatorComponent],
})
export class SaveIndicatorModule {}
